
var Heap = function(increasing, compare) {
    this._content = [];
    this._increasing = increasing;   // by default decreasing heap: element with lowest cost will be on top
    this._compare = compare ? compare : function (a,b) { return a - b; };
};

var HeapItem = function (obj,cost) {
    this.obj = obj;
    this.cost = cost;
};

Heap.prototype.empty = function() {
    this._content = [];
};

Heap.prototype.isEmpty = function() {
    return this._content.length === 0;
};

Heap.prototype.size = function() {
    return this._content.length;
};

Heap.prototype.insert = function(obj, cost) {
    this._content.push(new HeapItem(obj, cost));
    this._swim(this._last());
};

Heap.prototype.push = function(obj, cost) {
    this.insert(obj, cost);
};

Heap.prototype.top = function() {
    if (!this.isEmpty()) return this._content[0].obj;
};

Heap.prototype.pop = function() {
    var last = this._last();
    if (last < 0) return;
    var result = this._content[0].obj;

    this._exch(0,last);
    this._content.splice(last,1);

    this._sink(0);

    return result;
};

// Internals
Heap.prototype._comp = function (i, j) {
    var a = this._content[i].cost;
    var b = this._content[j].cost;
    if(this._increasing) return this._compare(a, b) < 0;
    else return this._compare(a, b) > 0;
};

Heap.prototype._last = function() {
    return this._content.length-1;
};

Heap.prototype._exch = function(i, j) {
    var temp = this._content[i];
    this._content[i] = this._content[j];
    this._content[j] = temp;
};

Heap.prototype._parent = function(index) {
    return ((index+1) >> 1) - 1;
};

Heap.prototype._leftChild = function(index) {
    return 2*(index+1) - 1;
};

Heap.prototype._hasLeftChild = function(index) {
    return this._leftChild(index) < this.size();
};

Heap.prototype._rightChild = function(index) {
    return 2*(index+1);
};

Heap.prototype._hasRightChild = function(index) {
    return this._rightChild(index) < this.size();
};

Heap.prototype._swim = function(index) {
    var current = index;
    while (current > 0 && this._comp(this._parent(current), current)) {
        this._exch(this._parent(current),current);
        current = this._parent(current);
    }
};

Heap.prototype._sink = function(index) {
    var current = index;

    while (this._hasLeftChild(current)) {
        var biggestChild = this._leftChild(current);
        if (this._hasRightChild(current) && this._comp(biggestChild,this._rightChild(current))) {
            biggestChild = this._rightChild(current);
        }

        if (this._comp(current,biggestChild)) {
            this._exch(current,biggestChild);
            current = biggestChild;
        } else {
            break;
        }

    }
};

module.exports = Heap;